import { Container } from "pixi.js";

/**
 * A full-screen game state. The Game owns exactly one at a time and drives its
 * lifecycle: `enter` once on activation, then `resize`/`update` until it is replaced.
 */
export abstract class Scene {
    protected readonly _container = new Container();

    public get container(): Container {
        return this._container;
    }

    /** Build the scene. Resolves when it is ready to be shown. */
    public abstract enter(width: number, height: number): Promise<void> | void;

    /** Per-frame update. `deltaSeconds` is real elapsed time, so speeds are per-second. */
    public update(deltaSeconds: number): void {}

    public resize(width: number, height: number): void {}

    public destroy(): void {
        this._container.destroy({ children: true });
    }
}
